<template>
  <div>
    <div class="pa-3">
      <v-text-field class="sf-search"
                    dense
                    flat
                    hide-details
                    prepend-inner-icon="ti-search"
                    solo
                    v-bind:placeholder="$t('search')"
                    v-model="search" />
    </div>
    <v-divider />
    <v-list class="sf-list">
      <template v-for="(item, index) in filteredItems">
        <v-list-item exact
                     two-line
                     v-bind:key="`${item.id}-list_item`"
                     v-bind:to="{ name: itemEditRouteName, params: { id: item.id } }">
          <v-list-item-avatar v-if="avatar && item.icon">
            <v-img v-bind:src="item.icon" />
          </v-list-item-avatar>
          <v-list-item-avatar class="sf-avatar"
                              v-else-if="avatar && item.code">
            <span>{{ item.code }}</span>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
            <v-list-item-subtitle>{{ item.subtitle }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider v-if="index !== filteredItems.length - 1"
                   v-bind:key="`${item.id}-divider`" />
      </template>
    </v-list>
  </div>
</template>

<script>
  export default {
    computed: {
      filteredItems() {
        if (this.search == null || this.search.count === 0) {
          return this.items
        }

        const search = this.search.toLowerCase()

        return this.items.filter(i => i.title.toLowerCase().includes(search))
      }
    },
    data: () => ({
      search: null
    }),
    name: 'NavigationList',
    props: {
      avatar: Boolean,
      defaultIcon: String,
      itemEditRouteName: String,
      items: Array
    }
  }
</script>

<i18n>
  {
    "de": {
      "search": "Suchen"
    },
    "en": {
      "search": "Search"
    }
  }
</i18n>
